import { authApi } from "../utils/apiClients";

// ✅ Generic function for GET requests (pagination supported)
export const apiGet = async (url, params = {}) => {
  try {
    if (params.pageNo !== undefined) {
      params._page = params.pageNo;
      delete params.pageNo;
    }
    if (params.pageSize !== undefined) {
      params._per_page = params.pageSize;
      delete params.pageSize;
    }
    const queryParams = new URLSearchParams(params).toString();
    const response = await authApi.get(
      `${url}${queryParams && "?"}${queryParams}`
    );
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

// ✅ Generic function for POST requests
export const apiPost = async (url, data) => {
  try {
    const response = await authApi.post(url, data);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

// ✅ Generic function for PATCH (Update) requests
export const apiUpdate = async (url, data) => {
  try {
    const response = await authApi.patch(url, data);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

// ✅ Generic function for DELETE requests
export const apiDelete = async (url) => {
  try {
    const response = await authApi.delete(url);
    return response.status === 200 || response.status === 204
      ? response.data
      : null;
  } catch (error) {
    return handleApiError(error);
  }
};

export const apiPutFormData = async (url, formData) => {
  try {
    const response = await authApi.put(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Required for FormData
      },
    });

    return response?.data;
  } catch (error) {
    return handleApiError(error);
  }
};

// ✅ Function to handle API errors and return meaningful messages
const handleApiError = (error) => {
  if (error.response) {
    return {
      isSuccess: false,
      statusCode: error.response.status,
      message: error.response.data?.message || "An error occurred",
      errors: error.response.data?.errors || [],
    };
  } else if (error.request) {
    return {
      isSuccess: false,
      statusCode: 500,
      message: "No response received from the server",
    };
  } else {
    return {
      isSuccess: false,
      statusCode: 500,
      message: error.message || "Something went wrong",
    };
  }
};
